import { Component, OnInit } from '@angular/core';
import {DashboardService} from '../../../modules/service/dashboard.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-widget-chequeinflow',
  templateUrl: './chequeinflow.component.html',
  styleUrls: ['./chequeinflow.component.scss']
})
export class ChequeinflowComponent implements OnInit {

  total:any;
  transact:any;
  pending:any;
  chequeamount:any;
  policytoday:any;

  loaderror:any='';
  loading:boolean = false;
  ud = JSON.parse(localStorage.getItem('userdata')); //get users email




  constructor(private service:DashboardService) { }

  ngOnInit() {


    this.loading = true
    this.service.Cashsegregate(this.ud.email, this.ud.role).subscribe(data=>{
      this.loading = false
      //this.total = parseFloat(data['cash'][0]['totalAmount'].replace(/,/g,''));
      this.chequeamount = parseFloat(data['cheque'][0]['totalAmount'].replace(/,/g,''));
      //this.policytoday = data['mobilemoney'][0]['totalAmount'];
      //console.log(this.total);
      

    }, error => {
      this.loading = false;
      this.loaderror = 'failed to fetch data. Reload';
      (Swal as any).fire({
        title: 'Oops...',
        text: error.name,
        footer: ''
      });
    }); 

  }



}
